import { render } from "./remove-recurring.vue?vue&type=template&id=6dd028b7"
import script from "./remove-recurring.vue?vue&type=script&lang=js"
export * from "./remove-recurring.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__